// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2BGkp","emails":"CreateEditClinics_emails__x0yiN","emailTagLabel":"CreateEditClinics_emailTagLabel__C2T62"};